import { Box } from '@mui/material';
import { styled } from '@mui/styles';
import React from 'react';
import { getStringProduct } from '../../utils/utilityFunctions';

const LayoutWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '90vw',
  margin: '80px auto 60px auto',
  // marginBottom: '60px',
  height: '100%',
  // height: 'calc(100vh - 170px)',
  [theme.breakpoints.down('xs')]: {
    margin: '40px auto auto auto'
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: '100vw'
  },
  [theme.breakpoints.up('xll')]: {
      margin: getStringProduct(1.25, '80px auto 60px auto'),
  },
  [theme.breakpoints.up('xlll')]: {
    margin: getStringProduct(1.66, '80px auto 60px auto'),
  },
  [theme.breakpoints.up('xl4')]: {
      margin: getStringProduct(2.46, '80px auto 60px auto'),
  }
}));

const Layout = ({ children }) => {
  return <LayoutWrapper component="main">{children}</LayoutWrapper>;
};

export default Layout;
